import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import RoutingEnum from 'constants/RoutingEnum';

import { RouteAction } from 'actions';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import ProductOption from 'PMT/entities/menu/ProductOption';

// -- views
import AbstractRestaurantMenuComponent from '../components/AbstractRestaurantMenuComponent';
import ProductOptionRow from './components/ProductOptionRow';
import RoundButton from 'components/RoundButton';

export default class OptionsListPage extends AbstractRestaurantMenuComponent {
  static propTypes = {
    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,
  };

  onAddOptionClicked = () => {
    RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_NEW);
  };

  //
  // Renderers
  //

  renderCreateOptionBtn() {
    if (!SecurityContext.restaurantMenu.canEditOptions()) {
      return null;
    }

    return (
      <RoundButton
        onClick={this.onAddOptionClicked}
        text={I18n.tr('menu.options_list.create_options')}
      />
    );
  }

  renderEmpty() {
    return (
      <div className="text-center">
        <h4>{I18n.tr('menu.options_list.no_options')}</h4>
      </div>
    );
  }

  renderTheadContent() {
    return (
      <tr>
        <th className="hidden-sm col-md-1 text-left" />
        <th className="col-md-3">{I18n.tr('menu.options_list.name')}</th>
        <th className="col-md-1 text-right" />
      </tr>
    );
  }

  renderList() {
    let productOptionsListView = [];

    _.each(this.restaurantMenu.options, (productOption: ProductOption) => {
      productOptionsListView.push(
        <ProductOptionRow
          productOption={productOption}
          restaurantMenu={this.restaurantMenu}
          key={productOption.id}
        />
      );
    });

    return (
      <div className="top-buffer-30 table_container">
        <table className="table table-responsive table-hover">
          <thead>{this.renderTheadContent()}</thead>
          <tbody>{productOptionsListView}</tbody>
        </table>
      </div>
    );
  }

  renderBody() {
    return (
      <div>
        {this.renderCreateOptionBtn()}

        {_.isEmpty(this.restaurantMenu.options) && this.renderEmpty()}
        {!_.isEmpty(this.restaurantMenu.options) && this.renderList()}
      </div>
    );
  }

  render() {
    return <div className="categories_list">{this.renderBody()}</div>;
  }
}
